module.exports = __webpack_public_path__ + "img/Message.66d7caf4.png";